import { render, staticRenderFns } from "./TaskReminder.vue?vue&type=template&id=d6090ffc&scoped=true&lang=pug&"
import script from "./TaskReminder.vue?vue&type=script&lang=js&"
export * from "./TaskReminder.vue?vue&type=script&lang=js&"
import style0 from "./TaskReminder.vue?vue&type=style&index=0&id=d6090ffc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6090ffc",
  null
  
)

export default component.exports